import { Link } from 'react-router';
import { Button } from '@/components/ui/button';

export function NotFoundPage() {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center text-center">
      <p className="text-muted-foreground text-xs font-medium uppercase tracking-wide">404</p>
      <h1 className="mt-2 text-xl font-semibold tracking-tight">Page not found</h1>
      <p className="text-muted-foreground mt-1 text-sm">The page you are looking for does not exist or you do not have access to it.</p>
      <Button asChild className="mt-6">
        <Link to="/jobs">Back to jobs</Link>
      </Button>
    </div>
  );
}
